import type { Ref, WritableComputedRef } from 'vue';
import { computed } from 'vue';
import type {
  HekateDisplayField,
  HekateDisplayFieldInteractiveStateType,
} from '@onshape/www-inertia';

// eslint-disable-next-line @typescript-eslint/no-extraneous-class
export default class FieldUtil {
  /** Bubble the model update:modelValue up */
  public static bubbleModel({
    get,
    emitter,
  }: {
    get: () => string | boolean;
    emitter: {
      emit: (_eventName: string, _eventVal: string | boolean) => void;
    };
  }): WritableComputedRef<string | boolean> {
    const bubbleModel = computed({
      get,
      set: (_evt) => {
        emitter.emit('update:modelValue', _evt);
      },
    });

    return bubbleModel;
  }

  /** Create a function that sends a blur event after a delay */
  public static lateBlur({
    field,
    emitter,
  }: {
    field: Ref<HekateDisplayField>;
    emitter: {
      emit: (_eventName: string, _eventVal: HekateDisplayField) => void;
    };
  }): () => void {
    return () => {
      setTimeout(() => {
        emitter.emit('blur', field.value);
      }, 25);
    };
  }

  /** Set the interactive state. */
  public static setInteractiveState({
    newState,
    field,
  }: {
    newState: HekateDisplayFieldInteractiveStateType;
    field: Ref<HekateDisplayField>;
  }): void {
    field.value.interactiveState = newState;
  }
}
